// extracted by mini-css-extract-plugin
export default {"error":"error-bar_error__jKGpt","message":"error-bar_message__g8Ade","icon":"error-bar_icon__vdpLY","warn_icon":"error-bar_warn_icon__yohAv","close_btn":"error-bar_close_btn__twmKo"};